import { FC, useEffect, MouseEvent } from "react";
import { useMutation } from "react-query";
import {
  Button,
  CircularProgress,
  Paper,
  TableContainer,
  Typography,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import TableComponent from "../../component/TableComponent";
import moment from "moment";
import {
  appointmentlistexcelService,
  appointmentlistpdfService,
  appointmentListService,
} from "../Service";
import { clinicId } from "../../../constants";
import useRepotFile from "../../hooks/reportFileHook";
const PatientReportv1: FC = () => {
  const { control, reset, 
    // handleSubmit, 
    getValues } = useForm();
  const {
    mutate: getReport,
    data: Data,
    isLoading: appointmentDataLoading,
    reset:resetMutation
  } = useMutation(appointmentListService);

  const { mutate: getappointmentReportpdf, isLoading: appointmentpdfLoading } =
    useRepotFile({ apiFunction: appointmentlistpdfService,responseFileKey:"file" });

  const {
    mutate: getappointmentReportexcel,
    isLoading: appointmentexcelLoading,
  } = useRepotFile({
    apiFunction: appointmentlistexcelService,
    fileType: "xlsx",
  });

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getappointmentReportpdf({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
        clinicId,
      });
    } else {
      getappointmentReportexcel({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
        clinicId,
      });
    }
  };

  // const onSubmit = (data: any) => {
  //   getReport({ ...data, clinicId });
  // };
  const onChange = ()=>{
    const data = getValues()
    if(data.fromDate && data.toDate){
      getReport({ ...data, clinicId });
    }else{
      resetMutation()
    }
  }
  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: ""
    });
    resetMutation()
  }

  useEffect(() => {
    getReport({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId,
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    });
  }, []);

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Appointment List Report
          </Typography>
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "to Date" }}
            rules={{ required: "to Date is required",onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button type="submit">search</Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={appointmentpdfLoading || !Boolean(Data?.response?.length) }
            endIcon={appointmentpdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf 
          </Button>
          <Button
            disabled={appointmentexcelLoading || !Boolean(Data?.response?.length) }
            endIcon={appointmentexcelLoading && <CircularProgress size={18} />}
            data-filetype="excel"
            onClick={getFiles}
          >
            download excel
          </Button>
        </div>
        <TableComponent
          loading={appointmentDataLoading}
          data={Data?.response || []}
          tableProps={heading}
          paginationChange={(prop) => {
            console.log(prop);
          }}
        />
      </TableContainer>
    </div>
  );
};

export default PatientReportv1;
const heading = [
  { heading: "NAME", key: "patientName" },
  { heading: "Doctor Name", key: "doctor" },
  { heading: "Department", key: "department" },
  { heading: "Mobile No", key: "mobile" },
  { heading: "Status", key: "status" },
  { heading: "Date", key: "bookingDate",date:"DD-MM-YYYY hh:mm A",format:"DD/MM/YYYY HH:mm:ss"  },
];
